import { Outlet } from "react-router-dom";
import { Flex } from "flux";
import LeftNav from "../components/left-navigation";

function InternalApp() {
  return (
    <Flex height="100vh" width="100%">
      <Flex flexShrink={0} sx={{ overflowY: "auto" }}>
        <LeftNav />
      </Flex>
      <Flex width="100%" flexDirection="column" sx={{ minWidth: 0 }}>
        <Flex height="100%" flexDirection="column" pb="16px" box-sizing="border-box" sx={{ overflowY: "auto" }}>
          <Outlet />
        </Flex>
      </Flex>
    </Flex>
  );
}

export default InternalApp;
